<span
  class="av-avatar av-avatar--{{ size() }}"
  [style.background-color]="backgroundColor()"
  [style.color]="textColor()"
>
  @if (showImage()) {
    <img
      class="av-avatar__image"
      [src]="photoUrl()"
      [alt]="'app.shared.avatar.altInitials' | translate: { name: name() }"
      (error)="onImageError()"
    />
  } @else if (hasInitials()) {
    <span
      class="av-avatar__initials"
      [attr.aria-label]="'app.shared.avatar.altInitials' | translate: { name: name() }"
      >{{ initials() }}</span
    >
  } @else {
    <mat-icon class="av-avatar__icon" aria-hidden="true">person</mat-icon>
  }
</span>
